import { BEDTO } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEDTOExtend {
  public static Init(dto: BEDTO) {
    dto.bEType = EnumBEType.BEDTO;
  }
}
